/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ weekOf: NonNullable<unknown>, tss: NonNullable<unknown> }} Ui_Labs_Weekly_Plan_SubtitleInputs */

const en_ui_labs_weekly_plan_subtitle = /** @type {(inputs: Ui_Labs_Weekly_Plan_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Week of ${i?.weekOf} — ${i?.tss} TSS`)
};

const de_ui_labs_weekly_plan_subtitle = /** @type {(inputs: Ui_Labs_Weekly_Plan_SubtitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Woche vom ${i?.weekOf} — ${i?.tss} TSS`)
};

/**
* | output |
* | --- |
* | "Week of {weekOf} — {tss} TSS" |
*
* @param {Ui_Labs_Weekly_Plan_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_labs_weekly_plan_subtitle = /** @type {((inputs: Ui_Labs_Weekly_Plan_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Labs_Weekly_Plan_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_labs_weekly_plan_subtitle(inputs)
	return de_ui_labs_weekly_plan_subtitle(inputs)
});